// extracted by mini-css-extract-plugin
export default {"zoomModal":"z1-z"};